import { motion } from "framer-motion";

/**
 * AnimatedSparkle
 * @param {number} size - Size of the sparkle (px)
 * @param {string} className - Additional classes for positioning
 * @param {string} animation - Animation type: "rotate-cw", "rotate-ccw", "scale"
 */
export default function AnimatedSparkle({
  size = 60,
  className = "",
  animation = "scale",
}) {
  // Define animation variants
  let animateProps = {};
  let transitionProps = { duration: 2, repeat: Infinity, ease: "easeInOut" };

  if (animation === "rotate-cw") {
    animateProps = { rotate: [0, 360] };
    transitionProps = { ...transitionProps, ease: "linear" };
  } else if (animation === "rotate-ccw") {
    animateProps = { rotate: [0, -360] };
    transitionProps = { ...transitionProps, ease: "linear" };
  } else if (animation === "scale") {
    animateProps = { scale: [1, 1.2, 1] };
  }

  return (
    <motion.div
      className={`inline-block ${className}`}
      style={{ width: size, height: size }}
      animate={animateProps}
      transition={transitionProps}
    >
      <svg
        viewBox="0 0 100 100"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full  rotate-[5deg]"
      >
        <path d="M50 0 Q60 40 100 50 Q60 60 50 100 Q40 60 0 50 Q40 40 50 0Z" />
      </svg>
    </motion.div>
  );
}


